export default __webpack_public_path__ + "static/10-7f92a41df329ac3a88eaeefc90e3de11.png";